module.exports = __webpack_public_path__ + "img/banner2-2@1x.3c1f022b.jpg";